import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import upload from "../../Admin/assets/images/upload-category.svg";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const AddPopup = ({ openDialog, setOpenDialog, edit, setEdit, selectedBanner, setGetbanners }) => {

  // Conditional dialog title and description
  const title = edit ? "Edit Banner" : "Add Banner";
  const description = edit
    ? "Update banner details."
    : "You can promote your business by promoting a banner";
  const [loading, setLoading] = useState(false)

  //handle close
  const handleClose = () => {
    setOpenDialog(false);
    setEdit(false);

    if (edit && selectedBanner) {
      setFormData({
        name: selectedBanner?.name || "",
        image: null,
        status: selectedBanner?.CommonStatus === "Active" ? "true" : "false",
      });
    } else {
      setFormData({
        name: "",
        image: null,
        status: "",
      });
      setImagePreview('')
    }
  };

  //banner api call
  const [formData, setFormData] = useState({
    name: "",
    status: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    if (edit && selectedBanner) {
      // Set form data for edit
      setFormData({
        name: selectedBanner?.name || "",
        image: null,
        status: selectedBanner?.CommonStatus === "Active" ? "true" : "false",
        banner_id: selectedBanner?.bannerId
      });
    } else {
      // Reset form data for add
      setFormData({
        name: "",
        image: null,
        status: "",
      });
      setImagePreview('')
    }
  }, [edit && selectedBanner]);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: files ? files[0] : value,
    }));
    // If the field is a file input, create a preview URL
    if (files && files[0]) {
      setImagePreview(URL.createObjectURL(files[0]));
    }
  };

  //addbanner
  const handleAddBanner = async () => {
    const { name, status, image } = formData;
    if (!name || !status || !image) {
      toast.error("All fields are required!");
      return;
    }
    try {
      setLoading(true)
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        data.append(key, value);
      });
      const response = await instance.post('/Banner/addBanner', data)

      if (response.data.success === true) {
        toast.success(response.data.message)
        handleClose();
        setGetbanners(true)
      } else {
        toast.error(response.data.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  //updateebanner
  const handleUpdateBanner = async () => {
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (key !== "image" || value !== null) {
          data.append(key, value);
        }
      });

      const response = await instance.put(`/Banner/editBanner`, data)
      if (response.data.success === true) {
        toast.success(response.data.message)
        handleClose();
        setGetbanners(true)
      } else {
        toast.error(response.data.message)
      }
    }
    catch (error) {
      toast.error(error?.response?.data?.message);
    }
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        className="admin-admins"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
          <Typography>{description}</Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <section className="add-admin">
            <Grid container spacing={3}>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <div className="admin-textfiled">
                  <TextField
                    placeholder="Enter banner title"
                    label="Banner"
                    type="text"
                    fullWidth
                    required
                    name="name"
                    size="small"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <div className='admin-textfiled'>
                  <FormControl fullWidth required>
                    <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Status"
                      required
                      placeholder="Select Status"
                      fullWidth
                      name="status"
                      value={formData.status}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "status",
                            value: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="true">Active</MenuItem>
                      <MenuItem value="false">Inactive</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <div className='upload-image-preview'>
                  <div className='file-upload-image'>
                    <Typography variant='h5'>Banner image upload *</Typography>
                    <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                      <img src={upload} alt="upload" />
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      name="image"
                      accept="image/*"
                      multiple
                      onChange={handleInputChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                {imagePreview && (
                  <div className="categoryimage-preview">
                    <ul>
                      <li>
                        <img
                          src={imagePreview}
                          alt="Selected or Existing"
                        />
                      </li>
                    </ul>
                  </div>
                )}
              </Grid>
            </Grid>
          </section>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="add-btn" onClick={edit ? handleUpdateBanner : handleAddBanner} disabled={loading}>
            {loading ? (
              <CircularProgress size={18} color="#fff" />
            ) : edit ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment >
  );
};

export default AddPopup;
